import {generateTestIds} from '../../../../utils/test-utils/data-test-id/generateTestIds';

const SCOPE = 'course.clients_list_item';

const KEYS = [
  'container',
  'avatar',
  'name',
  'initial_email',
  'label',
  'message',
  'course_label',
  'button_more',
  'button_resend',
  'button_cancel',
] as const;

type Key = (typeof KEYS)[number];

export const TestID = generateTestIds<Key>(SCOPE, KEYS);
